/**
 * Precise validation errors for the core module.
 * All messages are user-presentable, in the tone of the old Godot app.
 */

export type PixelwerkstattErrorCode =
  | "DIMENSION_TYPE"
  | "DIMENSION_RANGE"
  | "PIXELS_TYPE"
  | "PIXELS_ROW_COUNT"
  | "PIXELS_ROW_TYPE"
  | "PIXELS_ROW_WIDTH"
  | "PIXEL_TOKEN"
  | "COLOR_TYPE"
  | "COLOR_FORMAT"
  | "COLOR_COMPONENT_RANGE"
  | "INPUT_EMPTY"
  | "INPUT_TOO_LARGE"
  | "JSON_PARSE"
  | "JSON_SHAPE"
  | "JSON_VERSION"
  | "JSON_VERSION_MISSING"
  | "JSON_FIELDS"
  | "UNKNOWN_FORMAT"
  | "DOCUMENT_STATE";

export class PixelwerkstattError extends Error {
  readonly code: PixelwerkstattErrorCode;
  /** Optional detail, e.g. the offending value or expected/actual counts. */
  readonly detail?: string;

  constructor(code: PixelwerkstattErrorCode, message: string, detail?: string) {
    super(message);
    this.name = "PixelwerkstattError";
    this.code = code;
    if (detail !== undefined) this.detail = detail;
  }
}

/** Normalize any thrown value into a PixelwerkstattError. */
export function toPixelwerkstattError(err: unknown): PixelwerkstattError {
  if (err instanceof PixelwerkstattError) return err;
  const message = err instanceof Error ? err.message : String(err);
  return new PixelwerkstattError("DOCUMENT_STATE", message);
}
